<template>
  <div
    class="pointer-events-none absolute inset-x-1/2 inset-y-0 w-screen -translate-x-1/2"
  ></div>
</template>
